export default ({ type }) => type === 'pod';



// WEBPACK FOOTER //
// ./src/common/utils/is-pod.js